import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';

import { styled } from '@mui/material/styles';
import theme from '../../theme';


export const TableCellgroupStyle = styled(TableCell)({
  backgroundColor: theme.palette.grey.w100,
  borderRight: `1px solid ${theme.palette.grey.w300}`,
  borderTop: '#fff',
  borderBottom: '#fff',

  '&:last-child': {
    borderRight: 'none',
  },
})

export const TableCellHeaderStyle = styled(TableCell)({
  '&:nth-of-type(4n)': {
    borderRight: `1px solid ${theme.palette.grey.w300}`,
  },
  '&:last-child': {
    borderRight: 'none',
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderBottom: `1px solid ${theme.palette.grey.w200}`,
  },
})

export const TableRowBodyStyle = styled(TableRow)({
  '&:hover': {
    backgroundColor: theme.palette.primary.w50,
  },
})

export const TableCellBodyStyle = styled(TableCell)({
  paddingTop: '10px',
  paddingBottom: '10px',
  textAlign: 'center',
  // overflow: 'hidden',
  // whiteSpace: 'nowrap',
  // textOverflow: 'ellipsis',
  whiteSpace: 'normal',
  wordBreak: 'break-word',

  '&:nth-of-type(4n)': {
    borderRight: `1px solid ${theme.palette.grey.w300}`,
  },

  '&:last-child': {
    borderRight: 'none',
  },
})

export const TableRowFooterStyle = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: 'transparent',
  },
  '&:last-child td, &:last-child th': {
    border: 'none',
  },
})

export const TableRowDataStyle = styled(TableRow)({
  '&:last-child td, &:last-child th': {
    borderBottom: 'none',
  },
})

export const fieldNameStyle = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}

